import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { LiveEditor } from '@/components/live-edit/live-editor';

function EditPage() {
  const { orgId, siteId } = Route.useParams();
  const { page } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <LiveEditor
      orgId={orgId}
      siteId={siteId}
      requestedPage={page}
      onPageChange={(slug) => void navigate({ search: { page: slug } })}
    />
  );
}

export const Route = createFileRoute('/app/$orgId/sites/$siteId/edit')({
  validateSearch: z.object({ page: z.string().max(500).optional() }),
  component: EditPage,
});
